import { render, staticRenderFns } from "./GameSourceReport.vue?vue&type=template&id=00996aee&scoped=true"
import script from "./GameSourceReport.vue?vue&type=script&lang=js"
export * from "./GameSourceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00996aee",
  null
  
)

export default component.exports